// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text[data-v-55517af6] {\n  margin-top: 10px;\n}\n", "",{"version":3,"sources":["webpack://./js/app/components/modal/LanguageSelect.vue"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB","sourcesContent":[".text[data-v-55517af6] {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
